/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Name_Too_LongInputs */



/**
* | output |
* | --- |
* | "File name is too long" |
*
* @param {Spaces_File_Name_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_name_too_long = /** @type {((inputs?: Spaces_File_Name_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Name_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Dateiname ist zu lang")
	return /** @type {LocalizedString} */ ("File name is too long")
});